import { ApiClient } from "../common/apiClient";
import { ApiResult } from "../common/apiResult";
import { getRequestOptions } from "../common/helpers";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api`;

interface GenerateApiKeyResponse {
  apiKey: string;
}

export interface GetApiKeyResponse {
  id: string,
  name: string,
  prefix: string,
  createdAt: string,
  lastUsedAt: string,
  isActive: boolean
}

interface GetApiKeysResponse {
  apiKeys: GetApiKeyResponse[]
}

interface DeleteApiKeyResponse {

}

interface CreateWebhookResponse {
  secret: string;
}

export interface GetWebhookResponse {
  id: string;
  name: string;
  url: string;
  isActive: boolean;
  createdAt: string;
}

interface GetWebHooksResponse {
  webhooks: GetWebhookResponse[]
}

export const ManageApiService = {
  generateApiKey: async (name: string): Promise<ApiResult<GenerateApiKeyResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.post<GenerateApiKeyResponse>(`${API_BASE}/manage/api-keys`, {
        name
      }, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to generate api key",
        },
      };
    }
  },
  getApiKeys: async (): Promise<ApiResult<GetApiKeysResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.get<GetApiKeysResponse>(`${API_BASE}/manage/api-keys`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to get api keys",
        },
      };
    }
  },
  deleteApiKey: async (id: string): Promise<ApiResult<DeleteApiKeyResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.delete<DeleteApiKeyResponse>(`${API_BASE}/manage/api-keys/${id}`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to delete api key",
        },
      };
    }
  },
  createWebhook: async (name: string, url: string): Promise<ApiResult<CreateWebhookResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.post<CreateWebhookResponse>(`${API_BASE}/manage/webhooks`, {
        name,
        url
      }, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to create webhook",
        },
      };
    }
  },
  deleteWebhook: async (id: string): Promise<ApiResult<CreateWebhookResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.delete<CreateWebhookResponse>(`${API_BASE}/manage/webhooks/${id}`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to create webhook",
        },
      };
    }
  },
  rotateWebhookSecret: async (id: string): Promise<ApiResult<CreateWebhookResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.put<CreateWebhookResponse>(`${API_BASE}/manage/webhooks/${id}/rotate`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to rotate webhook secret",
        },
      };
    }
  },
  getWebhooks: async (): Promise<ApiResult<GetWebHooksResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.get<GetWebHooksResponse>(`${API_BASE}/manage/webhooks`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to get webhooks",
        },
      };
    }
  },
};